import DonDaGiaiQuyet from './DonDaGiaiQuyet.jsx';
export {
  DonDaGiaiQuyet
}


// WEBPACK FOOTER //
// ./src/components/modules/don-da-giai-quyet/index.js